<div class="purchase-confirmation flex flex--column grow--min">
  <div class="purchase-success-content flex-1 mobile-bleed">
    <ng-container [ngSwitch]="state$ | async">
      <!-- CASE 1/3: SHOW LOADING INDICATOR -->
      <fin-loader *ngSwitchCase="PageState.LOADING" [type]="LoaderType.EMBEDDED"></fin-loader>

      <!-- CASE 2/3: SHOW ORDER DATA -->
      <div *ngSwitchCase="PageState.DONE">
        <fin-booking-plain-header-area
          *ngIf="!enableSynchronousTicketingOnConfirmationPage"
          [title]="'purchase.success.title' | finLocalization"
        ></fin-booking-plain-header-area>

        <fin-section-review
          *ngIf="!enableSynchronousTicketingOnConfirmationPage"
          class="purchase-confirmation-booking-info"
          [title]="'purchase.success.yourBookingRef' | finLocalization"
          [fullWidth]="true"
        >
          <ng-container ngProjectAs="content">
            <div class="font-body-1 pr-small-x ps-small-t fill" data-hj-suppress>
              <div
                data-testid="purchase-order-booking-ref"
                class="order-booking-ref bold-type font-heading-2 heather-700-text"
              >
                {{ (orderData$ | async)?.id }}
              </div>
              <div class="ps-small-y">
                <p *ngIf="(emails$ | async).length === 1" class="font-body-1 ps-small-b">
                  {{ 'purchase.success.emailInfoText' | finLocalization }}:
                </p>
                <p *ngIf="(emails$ | async).length > 1" class="font-body-1 ps-small-b">
                  {{ 'purchase.success.emailInfoTextMulti' | finLocalization }}:
                </p>
                <ul class="ps-medium-x">
                  <li *ngFor="let email of emails$ | async" class="medium-type lowercase">
                    {{ email }}
                  </li>
                </ul>
              </div>
            </div>
            <fcom-button
              data-testid="mmb-button"
              *ngIf="!nativeBridgeService.isInsideNativeWebView"
              class="pr-small-x"
              [theme]="ButtonTheme.LIGHT_PRIMARY_CTA_HEATHER"
              [mode]="ButtonMode.FILL_MOBILE"
              [text]="'purchase.success.ctaButton' | finLocalization"
              (clickBtn)="goToMMB()"
            ></fcom-button>
            <fcom-button
              data-testid="mmb-button-app"
              *ngIf="enableAppCtaButton && appUrl$ | async as appUrl"
              class="pr-small-x"
              [theme]="ButtonTheme.LIGHT_PRIMARY_CTA_HEATHER"
              [mode]="ButtonMode.FILL_MOBILE"
              [text]="'purchase.success.ctaButtonApp' | finLocalization"
              (clickBtn)="openInApp(appUrl)"
            ></fcom-button>
            <span class="grey-100-bg fill rounded-bottom-large pr-small-x ps-xsmall-y mr-small-t font-body-1">
              {{ 'purchase.success.ticketDeliveryNote' | finLocalization }}
            </span>
          </ng-container>
        </fin-section-review>

        <fin-booking-plain-header-area
          *ngIf="enableSynchronousTicketingOnConfirmationPage"
          [title]="
            ((hasBeenIssuedETickets$ | async) ? 'purchase.success.title' : 'purchase.success.ticketNotOkTitle')
              | finLocalization
          "
        ></fin-booking-plain-header-area>

        <fin-section-review
          *ngIf="enableSynchronousTicketingOnConfirmationPage"
          class="purchase-confirmation-booking-info"
          data-testid="purchase-confirmation-booking-information"
          [title]="'purchase.success.yourBookingRef' | finLocalization"
          [fullWidth]="true"
        >
          <ng-container ngProjectAs="content">
            <div class="font-body-1 pr-small-x ps-small-t fill" data-hj-suppress>
              <div
                data-testid="purchase-order-booking-ref"
                class="order-booking-ref bold-type font-heading-2 heather-700-text"
              >
                {{ (orderData$ | async)?.id }}
              </div>
            </div>

            <div
              *ngIf="(hasBeenIssuedETickets$ | async) === false"
              data-testid="purchase-confirmation-etickets-not-issued"
            >
              <p class="pr-small-x font-body-1 ms-small-y">
                {{ 'purchase.success.ticketNotOkDescription' | finLocalization }}
              </p>
              <fcom-notification class="mr-small-x mr-small-b">
                <p
                  *ngIf="!(unconfirmedAndPendingServices$ | async).length"
                  [innerHTML]="'purchase.success.ticketNotOkNoTravelExtrasNotification' | finLocalization"
                  class="font-body-1"
                ></p>
                <p
                  *ngIf="(unconfirmedAndPendingServices$ | async).length"
                  class="font-body-1"
                  [innerHTML]="'purchase.success.ticketNotOkTravelExtrasNotOkNotification' | finLocalization"
                ></p>
              </fcom-notification>
            </div>

            <div
              *ngIf="(hasBeenIssuedETickets$ | async) === true"
              data-testid="purchase-confirmation-etickets-issued"
              class="flex flex--column"
            >
              <p class="pr-small-x font-body-1 ms-small-t" *ngIf="!(paidIncludedServices$ | async).length">
                {{ 'purchase.success.ticketOkNoTravelExtrasDescription' | finLocalization }}
              </p>
              <p class="pr-small-x font-body-1 ms-small-t" *ngIf="(paidIncludedServices$ | async).length">
                {{
                  ((unconfirmedAndPendingServices$ | async).length
                    ? 'purchase.success.ticketOkTravelExtrasNotOkDescription'
                    : 'purchase.success.ticketOkTravelExtrasOkDescription'
                  ) | finLocalization
                }}
              </p>
              <ul class="ps-medium-x mr-small-x mr-small-b">
                <li *ngFor="let email of emails$ | async" class="medium-type lowercase">
                  {{ email }}
                </li>
              </ul>
              <ng-container *ngIf="unconfirmedAndPendingServices$ | async as unconfirmedAndPendingServices">
                <fcom-notification
                  *ngIf="unconfirmedAndPendingServices.length"
                  data-testid="purchase-confirmation-unconfirmed-services-notification"
                  class="mr-small-x mr-small-b"
                >
                  <h4 class="font-body-1 bold-type ms-small-b">
                    {{ 'purchase.success.ticketOkTravelExtrasNotOkNotification.title1' | finLocalization }}
                  </h4>
                  <p class="font-body-1">
                    {{ 'purchase.success.ticketOkTravelExtrasNotOkNotification.para1' | finLocalization }}
                  </p>
                  <h4 class="font-body-1 bold-type ms-small-y">
                    {{
                      'purchase.success.ticketOkTravelExtrasNotOkNotification.title2'
                        | finLocalization
                          : {
                              travelExtrasList: (unconfirmedAndPendingServices | finMap: 'title').join(', '),
                            }
                    }}
                  </h4>

                  <p
                    class="font-body-1"
                    [innerHTML]="'purchase.success.ticketOkTravelExtrasNotOkNotification.para2' | finLocalization"
                  ></p>
                </fcom-notification>

                @if (unconfirmedAndPendingServices.length) {
                  <p
                    class="font-body-1 pr-small-x mr-small-b"
                    [innerHTML]="'purchase.success.ticketOkTravelExtrasOkCheckEmailDisclaimer' | finLocalization"
                  ></p>
                }

                @if (!unconfirmedAndPendingServices.length) {
                  <p
                    class="mr-small-x mr-small-b"
                    [innerHTML]="
                      ((paidIncludedServices$ | async).length
                        ? 'purchase.success.ticketOkTravelExtrasOkCheckEmailDisclaimer'
                        : 'purchase.success.ticketOkNoTravelExtrasCheckEmailDisclaimer'
                      ) | finLocalization
                    "
                  ></p>
                }
              </ng-container>
            </div>

            <fcom-button
              data-testid="mmb-button"
              *ngIf="!nativeBridgeService.isInsideNativeWebView"
              class="pr-small-x mr-small-b"
              [theme]="ButtonTheme.LIGHT_PRIMARY_CTA_HEATHER"
              [mode]="ButtonMode.FILL_MOBILE"
              [text]="'purchase.success.ctaButton' | finLocalization"
              (clickBtn)="goToMMB()"
            ></fcom-button>
            <fcom-button
              data-testid="mmb-button-app"
              *ngIf="enableAppCtaButton && appUrl$ | async as appUrl"
              class="pr-small-x mr-small-b"
              [theme]="ButtonTheme.LIGHT_PRIMARY_CTA_HEATHER"
              [mode]="ButtonMode.FILL_MOBILE"
              [text]="'purchase.success.ctaButtonApp' | finLocalization"
              (clickBtn)="openInApp(appUrl)"
            ></fcom-button>
          </ng-container>
        </fin-section-review>

        @if (hasCorporateSeatBenefit$ | async) {
          <div class="white-bg rounded-large border pr-small ms-medium-t">
            <h2 class="font-heading-4 flex flex--middle nordic-blue-900-text">
              <fcom-icon [name]="SvgLibraryIcon.B2B_BLOCK" class="icon-large ms-xsmall-r"></fcom-icon>
              <span class="block">{{ 'purchase.success.corporateSeatBenefitTitle' | finLocalization }}</span>
            </h2>
            <div class="ms-medium-t font-body-1 regular-type">
              {{ 'purchase.success.corporateSeatBenefit' | finLocalization }}
            </div>
            @if (hasBeenIssuedETickets$ | async) {
              <fcom-button
                class="ms-medium-t"
                data-testid="corporate-seat-benefit-cta-button"
                [theme]="ButtonTheme.LIGHT_PRIMARY_CTA_HEATHER"
                [text]="'purchase.success.corporateSeatBenefitButton' | finLocalization"
                (clickBtn)="openCorporateSeatBenefit()"
              ></fcom-button>
            }
            @if ((hasBeenIssuedETickets$ | async) === false) {
              <fcom-notification class="mr-small-t">
                <p class="font-body-1">
                  {{ 'purchase.success.corporateSeatBenefitWaitForTickets' | finLocalization }}
                </p>
              </fcom-notification>
            }
          </div>
        }

        <fin-section-review
          class="ms-medium-t purchase-review-renewed-prices"
          [fullWidth]="true"
          [noButton]="true"
          [roundedBottom]="false"
        >
          <ng-container ngProjectAs="content">
            <fin-price-breakdown-renewed
              class="flex--basis-full"
              [prices$]="orderData$ | finMap: 'prices.included'"
              [passengers$]="orderData$ | finMap: 'passengers'"
              [showPoints]="showPoints$ | async"
            >
              <fcom-notification
                data-testid="points-notification"
                *ngIf="
                  ((orderData$ | finMap: 'serviceFlow' | async) === ServiceFlow.BOOKING ||
                    (orderData$ | finMap: 'serviceFlow' | async) === ServiceFlow.AWARD) &&
                  (orderData$ | finMap: 'prices.included.total.total.totalPoints' | async)
                "
                class="ps-small-y"
              >
                {{ 'purchase.success.pointsUsedToPay' | finLocalization }}
              </fcom-notification>
            </fin-price-breakdown-renewed>
          </ng-container>
        </fin-section-review>

        <fin-grand-total
          [theme]="GrandTotalTheme.RENEWED"
          [useSymbol]="true"
          class="purchase-review-total-prices block"
          data-testid="purchase-success-grand-total"
          [prices$]="orderData$ | finMap: 'prices.included'"
          [serviceFlow$]="orderData$ | finMap: 'serviceFlow'"
        ></fin-grand-total>

        <div *ngIf="showCorporateUpsell$ | async" class="flex container flex--space-between">
          <fin-promotion-banner
            class="flex flex--row fill banner-card mr-xsmall-t white-bg border rounded-large overflow-hidden"
            [imageFromFragment]="'fragments.upsellBusinessLongHaulOldCabin'"
            [translationPrefix]="'corporate.predict'"
            [url]="'corporate.predict.url.url' | finLocalization"
            [imagePosition]="'left'"
            [buttonIcon]="{
              name: SvgLibraryIcon.ARROW_RIGHT,
              position: IconPosition.RIGHT,
            }"
          >
          </fin-promotion-banner>
        </div>
        <div>
          <ng-container *ngIf="surveyInfo$ | async as surveyInfo">
            <fin-section-review
              class="ms-medium-t feedback-form"
              [title]="'feedback.heading' | finLocalization"
              [noButton]="true"
            >
              <ng-container ngProjectAs="content">
                <div class="flex flex--column flex--nowrap">
                  <fcom-button
                    [text]="'feedback.ctaButton' | finLocalization"
                    [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
                    (clickBtn)="openModal($event)"
                  ></fcom-button>
                  <fin-qualtrics [survey]="surveyInfo" [(open)]="openSurvey"></fin-qualtrics>
                </div>
              </ng-container>
            </fin-section-review>
          </ng-container>
          <div class="flex flex--center mr-large-b">
            <fcom-button
              *ngIf="!nativeBridgeService.isInsideNativeWebView"
              data-testid="home-button"
              [theme]="ButtonTheme.LIGHT_TERTIARY_GHOST"
              class="ms-medium-t pr-small-l"
              [text]="'bookingConfirmation.cta' | finLocalization"
              [icon]="{
                name: SvgLibraryIcon.ARROW_RIGHT,
                position: IconPosition.RIGHT,
              }"
              (clickBtn)="goToHomePage()"
            >
            </fcom-button>
          </div>
        </div>
      </div>
      <!-- CASE 3/3: SHOW ERROR -->
      <fin-bound-selection-error-message
        *ngSwitchCase="PageState.ERROR"
        (ctaClick)="loadOrderErrorClick.emit(true)"
        [ctaButtonText]="'bookingSearch.tryAgain' | finLocalization"
      >
        <span class="title">{{ 'serverErrorCodes.loadOrderFailed' | finLocalization }}</span>
      </fin-bound-selection-error-message>
    </ng-container>
  </div>
</div>
